import {IAnswer} from "./Answer";
import {IQuestion} from "./Question";
import {TopicPairStatus} from "./enums/TopicPairStatus";
import { TopicPairContentType } from "./enums/TopicPairContentType";

export interface ITopicPair {
    topicPairId: number;
    triggerName: string;
    answer?: IAnswer;
    subject: string;
    source: string; 
    questions: IQuestion[];
    status: TopicPairStatus;
    contentType: TopicPairContentType;
    publishStatus: ITopicPairPublishStatus;
}

export enum ITopicPairPublishStatus {
    Added,
    Published,
    Edited,
    Removed,
}
